import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2 = {
  title:
    "Configuration-driven platform\n— actions are defined by\nconfigurations",
  subtitle: "Network operations demo",
  text: "Experiencing the flexibility and efficiency of a\nconfiguration-driven approach.",
  label: { iconPath: "start.png", text: "Event Configuration and Enrichment" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_208"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_206"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_demo_screens_base.png",
  rightSideVideo: "ILO/ILO2/INF_CMT_827.23_Network Demo_Part 4_R1.mp4",
  pageNumber: "ILO_207",
};

export default DATA_NO_DEMO_ILO2;
